import React from "react";
import { Box, Container, Typography, useTheme, useMediaQuery } from "@mui/material";
import Security from "../assets/Security.png";

export default function SecuritySolutions() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: "#fff" }}>
      <Container
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row-reverse" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 6, md: 8 },
        }}
      >
        {/* === Image Section === */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src={Security}
            alt="Security Solutions"
            sx={{
              width: { xs: "90%", sm: "80%", md: "100%" },
              maxWidth: 550,
              borderRadius: 0,
              boxShadow: "none",
              objectFit: "contain",
              transition: "transform 0.6s ease",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
          />
        </Box>

        {/* === Text Section === */}
        <Box
          sx={{
            flex: 1,
            maxWidth: 600,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography
            variant="h4"
            fontWeight={800}
            mb={3}
            sx={{
              background: "linear-gradient(90deg, #1976d2, #004ba0)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Our Security Solutions
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ lineHeight: 1.8, fontSize: "1.05rem", mb: 2 }}
          >
            We deliver comprehensive, technology-driven, and human-powered
            security management across multiple industries. With a strong regional
            presence, we ensure adaptable and reliable protection systems for every need.
          </Typography>

          {/* === Bullet Points === */}
          <Box
            component="ul"
            sx={{
              pl: isMobile ? 0 : 2,
              listStyleType: "none",
              textAlign: { xs: "center", md: "left" },
              color: "text.secondary",
            }}
          >
            {[
              "We are flexible and adaptable to your needs.",
              "We serve across multiple segments.",
              "We have a strong regional reach and approach.",
              "We are backed by ex-defense and fire safety experts.",
              "We offer on-site, mobile, and remote guarding systems.",
            ].map((point, index) => (
              <Typography
                key={index}
                component="li"
                variant="body1"
                sx={{
                  mb: 1.2,
                  "&::before": {
                    content: '"• "',
                    color: theme.palette.primary.main,
                    fontWeight: 700,
                  },
                }}
              >
                {point}
              </Typography>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
